import React from "react";
import "../components/css/style.css";
import "../components/css/legal.css";
import BreadcrumbIllustration from "../assets/imgs/img_banner.png";

export default function TermsOfServiceSection() {
    const handleHomeClick = (e) => {
        e.preventDefault();
        window.location.href = "/";
    };

    return (
        <div className="abt-section">
            <div className="abt-container">
                <div className="abt-left">
                    <h1 className="abt-title">
                        <span className="abt-highlight">Terms of Service</span>
                    </h1>

                    <div className="abt-breadcrumb">
                        <span className="abt-crumb abt-home" onClick={handleHomeClick}>Home</span>
                        <span className="abt-crumb abt-active">Terms of Service</span>
                    </div>
                </div>

                <div className="abt-right">
                    <div className="abt-image-wrapper">
                        <img
                            src={BreadcrumbIllustration}
                            alt="Illustration"
                            className="abt-image"
                        />
                    </div>
                    <div className="abt-glow"></div>
                    <div className="abt-glow abt-glow-second"></div>
                </div>
            </div>

            <section className="pp-section">
                <div className="pp-container">
                    <div className="pp-content">
                        <p>
                            Welcome to RhythmGrowthLab. These Terms of Service ("Terms") govern your use of our website, services, and deliverables. By engaging with us, you agree to be bound by these Terms. Please read them carefully.
                        </p>

                        <h2>1. Introduction & Acceptance</h2>
                        <p>
                            RhythmGrowthLab ("Company", "we", "us", "our") provides Website Development, Mobile App Development, Branding, Digital Marketing, and Performance Marketing services. By accessing our website, submitting a service request, signing a proposal, or making a payment, you ("Client", "you", "your") acknowledge that you have read, understood, and agree to be bound by these Terms.
                        </p>

                        <h2>2. Scope of Services</h2>
                        <p>RhythmGrowthLab agrees to provide services as outlined in the project proposal, agreement, or invoice shared with the Client. The scope includes:</p>
                        <ul>
                            <li>Website Development (as per agreed specifications)</li>
                            <li>Mobile App Development (Android & iOS)</li>
                            <li>Brand Identity Design</li>
                            <li>Digital Marketing campaigns</li>
                            <li>Performance Marketing (Meta / Google Ads)</li>
                            <li>Any additional services agreed upon in writing</li>
                        </ul>
                        <p>
                            Any changes or additions to the scope must be mutually agreed upon in writing and may involve additional charges.
                        </p>

                        <h2>3. Client Responsibilities</h2>
                        <p>The Client is solely responsible for:</p>
                        <ul>
                            <li>Providing accurate, complete, and timely information, materials, content, logos, media, and approvals</li>
                            <li>Ensuring ownership or proper licensing rights to all content provided</li>
                            <li>Compliance with Meta, Google, App Store, Play Store, and all third-party platform policies</li>
                            <li>Compliance with all applicable laws, regulations, and advertising standards</li>
                            <li>Reviewing deliverables and providing timely feedback</li>
                            <li>Maintaining backups of their own data and content</li>
                        </ul>

                        <h2>4. Payment Terms</h2>
                        <p>
                            Upon receipt of an invoice from RhythmGrowthLab, all payments must be made through officially shared payment methods only:
                        </p>
                        <ul>
                            <li>UPI</li>
                            <li>Razorpay</li>
                            <li>Payoneer</li>
                            <li>PayPal</li>
                            <li>Any officially approved business payment method</li>
                        </ul>
                        <p><strong>Important Payment Conditions:</strong></p>
                        <ul>
                            <li>Payments made to any unauthorized or third-party account shall not be considered valid</li>
                            <li>Invoices are due as per the date mentioned on the invoice</li>
                            <li>Late payments may result in service suspension or project delays</li>
                            <li>All fees are exclusive of taxes unless stated otherwise. Taxes (GST, etc.) will be added as applicable</li>
                        </ul>

                        <h2>5. Non-Refundable & Non-Transferable Policy</h2>
                        <p>
                            All fees paid for services are <strong>non-refundable and non-transferable</strong>, including but not limited to:
                        </p>
                        <ul>
                            <li>Website Development</li>
                            <li>Mobile App Development (Android & iOS)</li>
                            <li>Brand Identity Design</li>
                            <li>Digital Marketing</li>
                            <li>Performance Marketing (Meta / Google Ads)</li>
                            <li>Any setup fees, consultation fees, or advance payments</li>
                        </ul>
                        <p>
                            Once a project or service has commenced, refund requests, cancellations, chargebacks, reversals, or partial payment disputes shall not be entertained under any circumstances.
                        </p>

                        <h2>6. Website Revisions & Post-Finalization Changes</h2>
                        <p>
                            For any website project, a maximum of <strong>6–7 changes</strong> (revisions) are included and accepted within the agreed scope of work.
                        </p>
                        <p>
                            Any additional changes beyond the included 6–7 revisions will be charged at <strong>Rs 1,200 per change</strong>.
                        </p>
                        <p>
                            Once the website is finalized and completed, any further changes requested by the Client — whether after one week, one month, or several months — will be charged at <strong>Rs 1,600 per change</strong>.
                        </p>
                        <p>
                            If the website is fully completed but <strong>1–2 minor items remain pending</strong>, and the Client fails to provide the required content, assets, information, or approvals within <strong>8–10 days</strong> of being requested, the website shall be considered <strong>fully completed and delivered</strong>. Any changes, additions, or modifications requested thereafter will be charged at <strong>Rs 1,600 per change</strong>.
                        </p>
                        <p>
                            All revision and post-finalization change charges must be paid in full before any further work, updates, or modifications are carried out on the finalized website.
                        </p>

                        <h2>7. Website Redesign</h2>
                        <p>
                            If a Client requests a complete website redesign after the project has been finalized and delivered, the <strong>full payment of the website</strong> will be charged again.
                        </p>
                        <p>
                            A request to change the <strong>color theme</strong> of the website shall also be considered as a website redesign and will be charged at the full website cost.
                        </p>
                        <p>
                            Website redesign charges must be paid in full before any redesign work is initiated.
                        </p>

                        <h2>8. Project Timeline & Delivery</h2>
                        <p>
                            Estimated project timelines are provided in good faith. Delays may occur due to:
                        </p>
                        <ul>
                            <li>Client feedback delays or unavailability</li>
                            <li>Changes in scope or requirements</li>
                            <li>Third-party platform issues (Meta, Google, App Store, Play Store, hosting providers, etc.)</li>
                            <li>Force majeure events</li>
                        </ul>
                        <p>
                            RhythmGrowthLab shall not be liable for any delays beyond our reasonable control. The Client acknowledges that timelines are estimates and not guarantees.
                        </p>

                        <h2>9. Intellectual Property Rights</h2>
                        <p><strong>Upon Full Payment:</strong></p>
                        <ul>
                            <li>Website code, design files, and app source code developed specifically for the Client shall be transferred to the Client upon full and final payment</li>
                            <li>RhythmGrowthLab retains the right to display completed work in portfolio, case studies, and marketing materials</li>
                        </ul>
                        <p><strong>Retained Rights:</strong></p>
                        <ul>
                            <li>RhythmGrowthLab retains ownership of any pre-existing tools, libraries, frameworks, templates, or proprietary code used during development</li>
                            <li>Any third-party assets, plugins, or licenses remain under their respective owners' terms</li>
                        </ul>
                        <p><strong>Client Content:</strong></p>
                        <ul>
                            <li>The Client retains ownership of all content, logos, images, and text they provide</li>
                            <li>The Client warrants that they have proper rights to all content provided</li>
                        </ul>

                        <h2>10. Limitation of Liability</h2>
                        <p>
                            To the maximum extent permitted by law, RhythmGrowthLab, its owner, team, or affiliates shall not be liable for:
                        </p>
                        <ul>
                            <li>Any indirect, incidental, special, consequential, or punitive damages</li>
                            <li>Loss of profits, revenue, data, or business opportunities</li>
                            <li>Ad account bans, suspensions, restrictions, or policy actions by Meta, Google, or any platform</li>
                            <li>Website or app rejection by App Store, Play Store, or any platform</li>
                            <li>Copyright or trademark disputes arising from Client-provided content</li>
                            <li>Third-party platform downtime, changes, or policy updates</li>
                            <li>Any damages exceeding the total amount paid by the Client to RhythmGrowthLab in the preceding 6 months</li>
                        </ul>

                        <h2>11. Disclaimer of Warranties</h2>
                        <p>
                            Services and deliverables are provided on an "AS IS" and "AS AVAILABLE" basis. RhythmGrowthLab makes no warranties, express or implied, regarding:
                        </p>
                        <ul>
                            <li>Specific results, traffic, rankings, conversions, or ROI from marketing campaigns</li>
                            <li>Uninterrupted, error-free, or secure operation of websites or applications</li>
                            <li>Approval or acceptance by Meta, Google, App Store, Play Store, or any third-party platform</li>
                            <li>Compatibility with third-party software or future platform updates</li>
                        </ul>
                        <p>
                            All implied warranties, including merchantability and fitness for a particular purpose, are disclaimed to the fullest extent permitted by law.
                        </p>

                        <h2>12. Indemnification</h2>
                        <p>
                            The Client agrees to indemnify, defend, and hold harmless RhythmGrowthLab, its owner, team, and affiliates from and against any and all claims, damages, losses, liabilities, costs, and expenses (including reasonable legal fees) arising out of or related to:
                        </p>
                        <ul>
                            <li>Client-provided content, materials, or information</li>
                            <li>Client's violation of any third-party rights, including intellectual property rights</li>
                            <li>Client's violation of Meta, Google, App Store, Play Store, or any platform policies</li>
                            <li>Client's violation of any applicable laws or regulations</li>
                            <li>Any unauthorized payment or chargeback initiated by the Client</li>
                        </ul>

                        <h2>13. Confidentiality</h2>
                        <p>
                            Both parties agree to keep confidential information private. Client business data, project details, and internal communications shall not be disclosed to third parties except:
                        </p>
                        <ul>
                            <li>As required by law</li>
                            <li>To service providers assisting in project delivery</li>
                            <li>With Client's written consent</li>
                        </ul>
                        <p>
                            RhythmGrowthLab may use non-sensitive project results, anonymized performance data, or completed samples for portfolio, case study, or internal analysis purposes unless objected to in writing.
                        </p>

                        <h2>14. Suspension & Termination</h2>
                        <p><strong>Suspension:</strong></p>
                        <p>
                            RhythmGrowthLab may suspend services immediately if:
                        </p>
                        <ul>
                            <li>Payments are overdue</li>
                            <li>Client violates any term of this agreement</li>
                            <li>Client engages in fraudulent, abusive, or illegal activity</li>
                        </ul>
                        <p><strong>Termination:</strong></p>
                        <ul>
                            <li>Either party may terminate ongoing services with written notice</li>
                            <li>Upon termination, Client remains liable for all work completed and fees incurred</li>
                            <li>No refunds shall be provided for terminated projects</li>
                            <li>RhythmGrowthLab reserves the right to refuse service to anyone for any reason</li>
                        </ul>

                        <h2>15. Ad Account & Platform Compliance</h2>
                        <p>
                            The Client acknowledges and agrees that:
                        </p>
                        <ul>
                            <li>Ad accounts, business managers, and platform accounts belong to the Client or their authorized entity</li>
                            <li>RhythmGrowthLab operates with granted access and permissions only</li>
                            <li>Meta, Google, and other platforms have their own policies. Violations may result in account restrictions, bans, or suspensions</li>
                            <li>RhythmGrowthLab is not responsible for any platform actions including account bans, ad rejections, or payment holds</li>
                            <li>The Client is responsible for ensuring their business practices comply with all platform policies</li>
                        </ul>

                        <h2>16. Third-Party Tools & Services</h2>
                        <p>
                            During project delivery, RhythmGrowthLab may utilize third-party tools, plugins, libraries, hosting services, or software. The Client acknowledges:
                        </p>
                        <ul>
                            <li>Additional license fees or subscription costs may apply for third-party tools</li>
                            <li>RhythmGrowthLab is not responsible for third-party tool uptime, security, or policy changes</li>
                            <li>Third-party tools are governed by their own terms of service and privacy policies</li>
                        </ul>

                        <h2>17. Force Majeure</h2>
                        <p>
                            RhythmGrowthLab shall not be liable for any delay or failure to perform resulting from causes outside our reasonable control, including but not limited to: natural disasters, war, terrorism, riots, labor conditions, governmental actions, internet outages, platform downtime, cyberattacks, or pandemics.
                        </p>

                        <h2>18. No Chargebacks</h2>
                        <p>
                            The Client agrees not to initiate any chargeback, payment reversal, or dispute with their bank or payment processor for any valid invoice issued by RhythmGrowthLab. Any unauthorized chargeback will result in:
                        </p>
                        <ul>
                            <li>Immediate suspension of all services</li>
                            <li>Referral to collections</li>
                            <li>Legal action for recovery plus all associated fees and costs</li>
                        </ul>

                        <h2>19. Entire Agreement</h2>
                        <p>
                            These Terms, together with any project proposal, invoice, or written agreement, constitute the entire agreement between RhythmGrowthLab and the Client. They supersede all prior or contemporaneous communications, whether oral or written.
                        </p>

                        <h2>20. Amendments & Modifications</h2>
                        <p>
                            RhythmGrowthLab reserves the right to update or modify these Terms at any time without prior notice. Changes will be posted on this page with an updated effective date. Continued use of our services after changes constitutes acceptance of the modified Terms.
                        </p>

                        <h2>21. Severability</h2>
                        <p>
                            If any provision of these Terms is found to be unenforceable or invalid, that provision shall be limited or eliminated to the minimum extent necessary, and the remaining provisions shall remain in full force and effect.
                        </p>

                        <h2>22. Waiver</h2>
                        <p>
                            Failure by RhythmGrowthLab to enforce any right or provision of these Terms shall not constitute a waiver of future enforcement of that right or provision.
                        </p>

                        <h2>23. Governing Law & Jurisdiction</h2>
                        <p>
                            These Terms and all related services shall be governed by and construed in accordance with the laws of <strong>India</strong>. Any disputes, claims, or legal proceedings arising out of or related to these Terms or services provided shall be subject to the <strong>exclusive jurisdiction</strong> of the courts in <strong>Delhi, India</strong>.
                        </p>

                        <h2>24. Contact Information</h2>
                        <p>
                            If you have any questions about these Terms of Service, please contact us at:<br />
                            <strong>Email:</strong> info@rhythmgrowthlab.com
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
}